import {Component, NgModule} from '@angular/core';
import {UserService} from '../../../../user/src/lib/user.service';
import {ApplyThemeDirectiveModule} from 'shared/lib/apply-theme/apply-theme.directive';
import {CommonModule} from '@angular/common';
import {TranslocoModule} from '@ngneat/transloco';
import {ClickOutsideDirectiveModule} from 'shared/lib/click-outside/click-outside.directive';
import {UserBarModule} from 'shared/lib/user-bar/user-bar.component';
import {NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'shared-user-bar-toggle',
	template: `
		<div libApplyTheme (click)="userBarVisible = true"
			 (libClickOutside)="userBarVisible=false"
			 *transloco="let t; read: 'userBar'" libApplyTheme [ngbTooltip]="t('userBar')" placement="left right" container="body">
				<div class="row justify-content-end align-items-center m-0" libApplyTheme (click)="userBarVisible = true"
					 (libClickOutside)="userBarVisible=false">
					<span class="font-weight-600 name">{{currentUser?.name}}</span>
				</div>
			<shared-user-bar [ngClass]="{visible: userBarVisible}"></shared-user-bar>
		</div>
	`,
	styleUrls: ['./user-bar-toggle.component.scss']
})
export class UserBarToggleComponent {
	userBarVisible = false;
	currentUser = this.user.user;

	constructor(private user: UserService) {
	}
}
@NgModule({
	declarations: [UserBarToggleComponent],
	imports: [
		CommonModule,
		TranslocoModule,
		ApplyThemeDirectiveModule,
		ClickOutsideDirectiveModule,
		UserBarModule,
		NgbTooltipModule
	],
	exports: [UserBarToggleComponent]
})
export class UserBarToggleModule {}
